import React from 'react';
import { ListPageScaffold, ListPageMain } from '../../components/common/list-page';
import InventoryRequests from '../../components/inventory/InventoryRequests';

const InventoryRequestsPage: React.FC = () => {
  return (
    <ListPageScaffold>
      <ListPageMain sectionGap={1}>
        <InventoryRequests />
      </ListPageMain>
    </ListPageScaffold>
  );
};

export default InventoryRequestsPage;
